import { signOut } from '@wundo/client/auth.ts';
import { leaveTo } from '@wundo/client/leaveTo.ts';
import { forgetAppTheme } from '@wundo/client/appTheme.ts';
import { customerAppUrl } from './config.ts';

/**
 * End the session and leave for the customer app.
 *
 * A full navigation in both directions: the customer app hosts the only login
 * screen, and leaving a session should leave no cached client state behind.
 *
 * A failed sign-out still leaves. A session outliving the click is the API's
 * problem, and staying put on a console that believes it is signed out is
 * nobody's idea of a fallback.
 */
export async function signOutAndLeave(): Promise<void> {
  forgetAppTheme();
  try {
    await signOut();
  } finally {
    leaveTo(customerAppUrl());
  }
}
